import type { StepGate } from "../api/types";

/**
 * "To complete this step" at the top of a step, from the server's gate. The same list as the footer's "Still
 * needed", but where a participant looks first, so nobody shortlists 20 jobs wondering why Complete stays grey.
 */
export function StepChecklist({ gate, done }: { gate: StepGate; done: boolean }) {
  if (done) return null;
  const left = gate.items.filter((item) => !item.done).length;
  return (
    <div className="mb-4 rounded-[var(--radius-card)] border border-border bg-surface p-4">
      <div className="mb-2 flex items-center justify-between gap-3">
        <b className="text-[14px]">To complete this step</b>
        <span className="text-[12px] text-text-muted">
          {left
            ? `${gate.items.length - left} of ${gate.items.length} done`
            : "All done. Complete the step below."}
        </span>
      </div>
      <ul className="m-0 flex list-none flex-col gap-1.5 p-0 text-[14px]">
        {gate.items.map((item) => (
          <li key={item.label} className="flex items-start gap-2">
            <span
              aria-hidden="true"
              className={`mt-px inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-[12px] font-bold ${
                item.done
                  ? "bg-positive text-white"
                  : "border-[1.5px] border-border-strong text-transparent"
              }`}
            >
              ✓
            </span>
            <span>
              <span className="sr-only">{item.done ? "Done: " : "To do: "}</span>
              {item.label}
              {item.detail ? <span className="text-text-muted"> ({item.detail})</span> : null}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
